import { Link } from 'react-router-dom';
import { HIGHLIGHTS } from '../../data/highlights';
import { assetUrl } from '../../lib/assetUrl';
import ArrowIcon from '../icons/ArrowIcon';
import './Welcome.css';

function HighlightCard({ highlight }) {
  const { title, description, image, linkTo, linkLabel } = highlight;

  return (
    <article className="highlight-card">
      <div className="highlight-card__media">
        <img src={assetUrl(image)} alt="" width="1900" height="1080" loading="lazy" />
      </div>
      <div className="highlight-card__body">
        <h3>{title}</h3>
        <p className="muted">{description}</p>
        <Link className="text-link" to={linkTo}>
          {linkLabel}
          <ArrowIcon />
        </Link>
      </div>
    </article>
  );
}

export default function Welcome() {
  return (
    <section className="section welcome" aria-labelledby="welcome-title">
      <div className="container">
        <div className="section-heading section-heading--center">
          <h2 id="welcome-title">Welcome to PAW Global Veterinary</h2>
          <p className="lead">
            Our Mission is to deliver comprehensive, compassionate, and expert veterinary care
            that enhances the well-being of pets and empowers pet owners—guided by our values.
          </p>
          <Link className="btn btn--secondary" to="/About">
            About Us
          </Link>
        </div>

        <div className="highlight-grid">
          {HIGHLIGHTS.map((highlight) => (
            <HighlightCard key={highlight.id} highlight={highlight} />
          ))}
        </div>
      </div>
    </section>
  );
}
